import { initTimelineCarousel } from '@components/sliders/sliders'

document.addEventListener('DOMContentLoaded', () => {
  initTimelineCarousel()
}, { once: true })
